import * as React from "react";
import { IconButton, Menu, PersonIcon } from "../../themeV2";
import { NavigationRenderer } from "../../navigation";
import UserBadges from "../Badges";
import UserDetails from "../UserDetails";

const AccountDashboardMenu = React.memo(function AccountDashboardMenu() {
  const [open, setOpen] = React.useState(false);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Menu.Root open={open} onOpenChange={setOpen}>
      <Menu.Trigger render={<IconButton label="Account menu" />}>
        <PersonIcon />
      </Menu.Trigger>

      <Menu.Popup side="bottom" align="end">
        <UserDetails fullName email avatar />
        <UserBadges />
        <NavigationRenderer context="account-menu" onLinkClick={handleClose} />
      </Menu.Popup>
    </Menu.Root>
  );
});

export default AccountDashboardMenu;
